import { Link } from 'react-router'

function TextLink({ ...props }) {
  return <Link {...props} className="text-action hover:underline" />
}

export default TextLink
